/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import { Pipe, PipeTransform } from '@angular/core';
import { IAviDropdownOption } from './avi-dropdown.types';
import { isFiltered } from './avi-dropdown.utils';

/**
 * @description Pipe to filter dropdown options by a searchTerm.
 * @author alextsg
 */
@Pipe({
    name: 'isFilteredBySearch',
    standalone: true,
})
export class IsFilteredBySearchPipe implements PipeTransform {
    public transform(
        options: IAviDropdownOption[],
        searchTerm: string,
        bypass = false,
    ): IAviDropdownOption[] {
        return options.filter(option => bypass || isFiltered(option, searchTerm));
    }
}
